module.exports = __webpack_public_path__ + "img/story008.82785fd4.webp";